namespace GeniuzPOS.InventoryReport {
    export interface IcReport07SkuWhsForm {
        SkuCode: Serenity.StringEditor;
        ShopId: Serenity.StringEditor;
        WhsId: Serenity.StringEditor;
        TranDate: Serenity.DateEditor;
        SysDocNo: Serenity.StringEditor;
        TranType: Serenity.StringEditor;
        QtyAdd: Serenity.DecimalEditor;
        QtyDel: Serenity.DecimalEditor;
        QtyBalance: Serenity.DecimalEditor;
        CostAdd: Serenity.DecimalEditor;
        CostDel: Serenity.DecimalEditor;
        CostBalance: Serenity.DecimalEditor;
    }

    export class IcReport07SkuWhsForm extends Serenity.PrefixedContext {
        static formKey = 'InventoryReport.IcReport07SkuWhs';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IcReport07SkuWhsForm.init)  {
                IcReport07SkuWhsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.DecimalEditor;

                Q.initFormType(IcReport07SkuWhsForm, [
                    'SkuCode', w0,
                    'ShopId', w0,
                    'WhsId', w0,
                    'TranDate', w1,
                    'SysDocNo', w0,
                    'TranType', w0,
                    'QtyAdd', w2,
                    'QtyDel', w2,
                    'QtyBalance', w2,
                    'CostAdd', w2,
                    'CostDel', w2,
                    'CostBalance', w2
                ]);
            }
        }
    }
}
